import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonCfgService } from './common-cfg.service';
import { CompanyParam } from './models/company-param';
import { DashboardDataCacheService } from './dashboard.data.cache.service';

@Injectable({
    providedIn: 'root'
})
export class CommonService {

    constructor(private httpClient: HttpClient, private commonCfgService: CommonCfgService, private dashboardDataCacheService: DashboardDataCacheService) { }

    /**
     * Obtiene los parámetros generales de un listado de claves-compañías a travez del api o desde la cache
     * @param companyParams Identificadores de la compañía
     * @returns Valores definidos de un parametro
     */
    getCompanyParams(companyParams: CompanyParam[]): Observable<CompanyParam[]> {
        return new Observable<CompanyParam[]>(observer => {
            let params = this.dashboardDataCacheService.getCompanyParamsExist(companyParams);
            if (params.length == 0) {
                observer.next(this.dashboardDataCacheService.getCompanyParams(companyParams));
                observer.complete();
            }
            else {
                this.getCompanyParamsApi(params).subscribe(response => {
                    this.dashboardDataCacheService.setCompanyParams(response);
                    observer.next(this.dashboardDataCacheService.getCompanyParams(companyParams));
                    observer.complete();
                }, (error => {
                    observer.error(error);
                }));
            }
        });
    }

    /**
     * Obtiene los parámetros generales de un listado de claves-compañías
     * @param companyParams Identificadores de la compañía
     * @returns Valores definidos de un parametro
     */
    getCompanyParamsApi(companyParams: CompanyParam[]): Observable<CompanyParam[]> {
        const url = `${this.commonCfgService.getCfg().apiCommonsEndpoint}companyparams`;
        return this.httpClient.put<CompanyParam[]>(url, companyParams);
    }

}
